import React from "react";
import { useTranslation } from "react-i18next";
import { PortfolioItemData } from "./Portfolio";

import styles from "../../assets/css/StudioGame.module.css";

export const StudioGame = ({
  image,
  title = "TBA",
  description = "TBA",
  links = [],
  tags = "TBA",
  limit = 155,
}: PortfolioItemData) => {
  const { t } = useTranslation();

  image ??= "/img/empty_project.png";
  const localizedDescription = t(description);

  const IsGoogle = (url: string) => url?.includes("play.google") ?? false;
  const IsApple = (url: string) => url?.includes("apple") ?? false;
  const IsItch = (url: string) => url?.includes("itch") ?? false;
  const IsSteam = (url: string) => url?.includes("steampowered") ?? false;

  const CustomBadge = ({ url }: any) => (
    <a
      href={url}
      target="_blank"
      rel="noreferrer"
      className={styles.customBadge}
    >
      {t("Play")}
    </a>
  );

  return (
    <div className={styles.item}>
      <img
        className={styles.image}
        src={window.location.origin + image}
        alt={`${title}_game`}
      />
      <div className={styles.itemText}>
        <p className={styles.title}>{title}</p>
        <p className={styles.description}>
          {localizedDescription.slice(0, limit)}
          {localizedDescription.length > limit ? ".." : ""}
        </p>
        {tags && (
          <div className={styles.tagsWrap}>
            <svg
              width="22"
              height="22"
              viewBox="0 0 22 22"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                cx="1.5"
                cy="1.5"
                r="1.5"
                transform="matrix(1 0 0 -1 15 7.00024)"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M1.77423 10.1439C0.771085 11.2643 0.749503 12.9546 1.67016 14.1437C3.49711 16.5033 5.49674 18.5029 7.85633 20.3298C9.0454 21.2505 10.7357 21.2289 11.8561 20.2258C14.8979 17.5022 17.6835 14.6559 20.3719 11.5279C20.6377 11.2187 20.8039 10.8397 20.8412 10.4336C21.0062 8.63798 21.3452 3.46467 19.9403 2.05974C18.5353 0.654811 13.362 0.993766 11.5664 1.15876C11.1603 1.19608 10.7813 1.36233 10.472 1.62811C7.34412 4.31646 4.49781 7.10211 1.77423 10.1439Z"
                stroke="currentColor"
                strokeWidth="1.5"
              />
              <path
                d="M6 13.0002L9 16.0002"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <b>{tags}</b>
          </div>
        )}
        <div className={styles.badges}>
          {links.map((link, i) => (
            <React.Fragment key={i}>
              {!IsGoogle(link) &&
                !IsApple(link) &&
                !IsItch(link) &&
                !IsSteam(link) &&
                links.length > 0 && <CustomBadge url={link} />}
              {(IsGoogle(link) ||
                IsApple(link) ||
                IsItch(link) ||
                IsSteam(link)) && (
                <a href={link} target="_blank" rel="noreferrer">
                  {IsGoogle(link) && (
                    <img
                      className={styles.badge}
                      src={
                        window.location.origin +
                        "/img/badges/google_play_badge.svg"
                      }
                      alt="google"
                    />
                  )}
                  {IsApple(link) && (
                    <img
                      className={styles.badge}
                      src={
                        window.location.origin +
                        "/img/badges/app_store_badge.svg"
                      }
                      alt="apple"
                    />
                  )}
                  {IsItch(link) && (
                    <img
                      className={styles.badge}
                      src={window.location.origin + "/img/badges/itch.svg"}
                      alt="itch"
                    />
                  )}
                  {IsSteam(link) && (
                    <img
                      className={styles.badge}
                      src={
                        window.location.origin + "/img/badges/steam_badge.png"
                      }
                      alt="steam"
                    />
                  )}
                </a>
              )}
            </React.Fragment>
          ))}
        </div>
      </div>
    </div>
  );
};
